import React from "react";
import PublicHolidays from "../employeeBirthdayAnniversaries/PublicHolidays";

interface DMRCCalendarProps {
  department?: any;
}

const DMRCCalendar: React.FC<DMRCCalendarProps> = () => {
  return <PublicHolidays pageTitle="DMRC Calendar" />;
};

export default DMRCCalendar;
